// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { kairos as _kairos } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the kairos chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 1001
 * Chain Name: Kairos Testnet
 * Default Block Explorer: https://kairos.kaiascope.com
 * Default RPC URL: https://public-en-kairos.node.kaia.io
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { kairos } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: kairos,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const kairos = createCommon({
	..._kairos,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
